// extracted by mini-css-extract-plugin
module.exports = {"wrap":"FeaturedText-module--wrap--wuxzL","content":"FeaturedText-module--content--1_S_N","noBorders":"FeaturedText-module--noBorders--3tZ_p"};